export default __webpack_public_path__ + "static/media/SpringBook_07.46c98caa.png";